import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import PagoCorrecto from '../views/PagoCorrecto.vue'
import PagoRechazado from '../views/PagoRechazado.vue'
import kushki from '../components/kushki.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'kushki',
    component: kushki
  },
  {
    path: '/PagoCorrecto',
    name: 'PagoCorrecto',
    component: PagoCorrecto
  },
  {
    path: '/PagoRechazado',
    name: 'PagoRechazado',
    component: PagoRechazado
  },
  // {
  //   path: '/CobroRechazado',
  //   name: 'CobroRechazado',
  //   component: CobroRechazado
  // },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
